<script lang="ts">
    import { useNavigate, useLocation } from "svelte-navigator";
    import { appManager } from "../AppManagerStore";

    const navigate = useNavigate();
    const location = useLocation();
    
	export let adminOnly: boolean = false;

    let hasUser: boolean = false;

    async function getUser() {
        if (await $appManager.Authenticator.isSignedIn()) {
            if (adminOnly) {
                const user = await $appManager.IdentityApi.getCurrentUser();
                if (user.isAdmin) {
                    hasUser = true;
                } else {
                    navigate("/notfound", {
                        state: { from: $location.pathname + $location.hash },
                        replace: true,
                    });
                }
            } else {    
                hasUser = true;
            }
        } else {
            const redirectUrl = window.location.href ?? $appManager.PublicUrl;

            navigate(`/signin?redirect=${redirectUrl}`, {
                state: { from: $location.pathname + $location.hash },
                replace: true,
            });
        }
    }
</script>

{#await getUser() then user}
    {#if hasUser}
        <slot />
    {/if}
{/await}
